module.exports = __webpack_public_path__ + "img/WOO_COMMERCE_ID.35c859cf.svg";